import React, { useState } from 'react';
import { TbHandFinger } from 'react-icons/tb';
import { Button } from './stylee';

const ScrollButton = () => {

    const [visible, setVisible] = useState(false)

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 100) {
            setVisible(true)
        } else if (scrolled <= 100) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
                /* you can also use 'auto' behaviour
                   in place of 'smooth' */
        });
    };

    window.addEventListener('scroll', toggleVisible);

    return ( < Button >
        <
        TbHandFinger onClick = { scrollToTop }
        style = {
            { display: visible ? 'inline' : 'none' }
        }
        /> </Button >
    );
}

export default ScrollButton;